<template>
    <div class="billing-counter-container">
        <div class="billing-counter-title">{{ text[type] }}</div>
        <div class="billing-counter">
            <div class="billing-counter-button" @click="decrement"><span class="material-icons">
                    remove
                </span>
            </div>
            <div class="billing-counter-value">
                <input type="text" v-model="counter" />
            </div>
            <div class="billing-counter-button" @click="increment"><span class="material-icons">
                    add
                </span></div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Counter",
    props: {
        value: {
            type: Number,
            default: 0,
        },
        type: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            counter: this.value,
            text: {
                supsis: this.$t("billing.numberOfRepresentatives"),
                whatsapp: this.$t("billing.numberOfChannels"),
                "whatsapp-business": this.$t("billing.numberOfChannels"),
                instagram: this.$t("billing.numberOfChannels"),
                messenger: this.$t("billing.numberOfChannels"),
                trendyol: this.$t("billing.numberOfChannels"),
                metaLead: this.$t("billing.numberOfChannels"),
            },
        };
    },
    watch: {
        value(newValue) {
            this.counter = newValue;
        },
        counter(newValue) {
            if (newValue !== this.value) {
                if (newValue < 1) {
                    this.counter = 1;
                    return;
                }
                this.$emit("input", newValue);
            }
        },
    },
    methods: {
        increment() {
            this.counter++;
            this.$emit("input", this.counter);
        },
        decrement() {
            if (this.counter > 1) {
                this.counter--;
                this.$emit("input", this.counter);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.billing-counter-container {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;

    .billing-counter-title {
        font-size: 1.4rem;
        font-weight: 500;
        color: #333;
        text-align: center;
    }

    .billing-counter {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 4px;
        border-radius: 8px;
        background-color: #f8f9fa;
        gap: 4px;

        &-button {
            cursor: pointer;
            color: #fff;
            background-color: #fa8231;
            border-radius: 6px;
            width: 32px;
            height: 32px;
            font-size: 1rem;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            user-select: none;
        }

        &-value {
            border-radius: 6px;
            background: white;
            width: 50px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #ddd;

            input {
                width: 100%;
                height: 100%;
                border: none;
                text-align: center;
                font-weight: 500;
                font-size: 1rem;
                background: white;
                border-radius: 6px;
                outline: none;
                color: #333;
            }
        }
    }
}
</style>